import { IS_BROWSER } from "@lib/constants";

export const setCookieExpiresInMinutes = (cname: string, cvalue: string, exMinutes: number) => {
  const d = new Date();
  d.setTime(d.getTime() + exMinutes * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

export const setCookie = (cname: string, cvalue: string, exdays: number) => {
  setCookieExpiresInMinutes(cname, cvalue, exdays * 24 * 60);
};

export const getCookie = (cname: string) => {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';').map(cookie => cookie.trim());
    const cookie = cookies.find(cookie => cookie.startsWith(name));
    return cookie ? cookie.substring(name.length) : '';
};

export const get_cookie = (name: string) => {
    return document.cookie.split(';').some(c => {
        return c.trim().startsWith(name + '=');
    });
};

export const delete_cookie = (name: string, path: string, domain: string) => {
    if (get_cookie(name)) {
        document.cookie = name + '=' +
            ((path) ? ';path=' + path : '') +
            ((domain) ? ';domain=' + domain : '') +
            ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
    }
};

const getDomainByHost = () => {
    if (IS_BROWSER) {
        const host = new URL(window.location.href).host;
        const hostInfo = host.split('.');
        let domain: string;
        if (host.indexOf('localhost:') > -1) {
            domain = 'localhost';
        } else {
            domain = `.${hostInfo[hostInfo.length - 2]}.${hostInfo[hostInfo.length - 1]}`;
        }
        return domain;
    }
    return '/';
};

export const deleteCookieByName = (name: string) => {
    const domain = getDomainByHost();
    delete_cookie(name, '/', domain);
};

export const deleteAllCookies = () => {
    const domain = getDomainByHost();
    document.cookie.split(';').some(name => {
        delete_cookie(name, '/', domain);
    });
};